import { Box, Icon } from 'ui';
import { styled, useMediaQuery, useTheme } from '@mui/material';
import SideLogoWelcomeSVG from './sideLogoWelcome';
import SideLogoImageSVG from './sideLogoImage.svg';
import SideLogoBackground from './sideLogoBackground.svg';

const Welcome = () => {
  const theme = useTheme();
  const isScreenLg = useMediaQuery(theme.breakpoints.up(1500));

  return (
    <Banner isScreenLg={isScreenLg}>
      <IconsContainer isScreenLg={isScreenLg}>
        <Icon name="cynetLogo" />
        <SideLogoWelcomeSVG isScreenLg={isScreenLg} />
      </IconsContainer>
      <BannerBackground />
    </Banner>
  );
};

const Banner = styled(Box, { shouldForwardProp: prop => prop !== 'isScreenLg' })<{ isScreenLg: boolean }>(
  ({ isScreenLg, theme }) => ({
    height: '100vh',
    width: isScreenLg ? '460px' : '300px',
    backgroundImage: `url(${SideLogoBackground})`,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundSize: '100vh',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  })
);

const IconsContainer = styled(Box, { shouldForwardProp: prop => prop !== 'isScreenLg' })<{ isScreenLg: boolean }>(
  ({ isScreenLg }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: isScreenLg ? '45px 45px 67px 45px' : '44px 100px 20px 20px',
    gap: isScreenLg ? '102px' : '28px'
  })
);

const BannerBackground = styled(Box)(() => ({
  height: '100%',
  width: '100%',
  backgroundRepeat: 'no-repeat',
  backgroundImage: `url(${SideLogoImageSVG})`,
  backgroundPosition: 'top',
  backgroundSize: '140%'
}));

export default Welcome;
